import { DASH_DEFAULT, NA_DEFAULT } from './Format/Format';

// This should be considered depricated
// use withDefaultsComparator instead
export const comparator = (a, b) =>
    (a === DASH_DEFAULT ? 0 : a) - (b === DASH_DEFAULT ? 0 : b);

// same as comparator but DASH_DEFAULT is considered less than any other value
export const withDefaultsComparator = (a, b) => {
    if (a === DASH_DEFAULT) {
        return -1;
    }
    if (b === DASH_DEFAULT) {
        return 1;
    }
    return a - b;
};

export const stringComparator = (a, b) =>
    (a === NA_DEFAULT ? DASH_DEFAULT : a).localeCompare(
        b === NA_DEFAULT ? DASH_DEFAULT : b
    );
